
export default function FAQCTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#0B1F3B] to-[#0B1F3B]/90">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Non hai trovato la risposta che cercavi?
        </h2>
        <p className="text-xl text-white/80 mb-10 leading-relaxed">
          Parliamone direttamente. Richiedi la tua pre-analisi gratuita e scopri il valore nascosto del tuo brand.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="/contatti" 
            className="inline-block bg-[#E879F9] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#E879F9]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Richiedi Pre-Analisi Gratuita
          </a>
          <a 
            href="/servizi" 
            className="inline-block bg-[#22C55E] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#22C55E]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Scopri i Servizi
          </a>
        </div>
      </div>
    </section>
  );
}
